var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18643",
    "data-name": "Rectangle 18643",
    width: 22,
    height: 22,
    transform: "translate(796 4167)",
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_52",
    "data-name": "Mask Group 52",
    transform: "translate(-796 -4167)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98848",
    "data-name": "Group 98848",
    transform: "translate(800.552 4167.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215692",
    "data-name": "Path 215692",
    d: "M20.41,3.8h2.082V0H18.708a5.072,5.072,0,0,0-5.16,3.716,9.94,9.94,0,0,0-.333,3.057l-3.46.011v3.987l3.464-.01V21.277H18.51V10.771h3.5v-4h-3.5V5.516C18.51,4.735,18.84,3.8,20.41,3.8Zm.727,3.846V9.9h-3.5V20.4h-3.54V9.884l-3.464.01V7.658l3.473-.01L14.094,7.2a10.292,10.292,0,0,1,.288-3.224A4.17,4.17,0,0,1,18.67.877h2.946v2.05H20.41a2.488,2.488,0,0,0-2.774,2.588V7.649Z",
    transform: "translate(-9.755 0)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/social2.dfd30f8fb57b745398f6c62b6c144e5f.svg";
export { ForwardRef as ReactComponent };